import React, { memo } from "react";
import styles from "./body.module.scss";

const Body = ({ children }) => {
  // const environment = envConfig;

  return (
    <>
      <div className={styles.Body}>{children}</div>
      {/* {environment === ENVIRONMENTS.PRODUCTION && <DatadogInit />} */}
    </>
  );
};

export default memo(Body);
